import { render, staticRenderFns } from "./AimStats.vue?vue&type=template&id=533e18be&"
import script from "./AimStats.vue?vue&type=script&lang=js&"
export * from "./AimStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports